export default __webpack_public_path__ + "static/dot-pattern-navyBlue-259142f734d420c46012d04f0faa4674.svg";